import { BillingEntity } from "../domain/Billing.entity";

export interface BillingDto {
  concept: string;
  currencyChange: number;
  currencyContract: string;
  currencyInvoice: string;
  discount: number;
  id: number;
  invoiceNumber: string;
  percentagePartner: number;
  period: string;
  propertyPartner: string;
  rate: number;
  ticker: string;
  totalRate: number;
  totalRateInvoice: number;
  totalRateMargin: number;
  units: number;
  value: number;
  tax: number;
  fp: string;
  legalName: string;
  cif: string;
  idMyS?: number;
  isVariable?: boolean;
  invoicePartner?: boolean;
}

export function toEntity(dto: BillingDto): BillingEntity {
  const priceUnit = dto.concept.includes("WitBooker - Min.") ? dto.rate : dto.value;
  const units = dto.concept.includes("WitBooker - Min.") ? 1 : dto.units;
  const currencyChange = dto.currencyChange > 0 ? 1 / dto.currencyChange : dto.currencyChange;
  return BillingEntity.of({
    invoiceNumber: dto.invoiceNumber,
    ticker: dto.ticker,
    partner: dto.propertyPartner,
    concept: dto.concept,
    period: dto.period,
    units,
    priceUnit,
    rate: dto.rate,
    totalRate: dto.totalRate,
    totalRateInvoice: dto.totalRateInvoice,
    totalRateMargin: dto.totalRateMargin,
    discount: dto.discount,
    currency: dto.currencyContract,
    currencyChange,
    percentagePartner: dto.percentagePartner,
    tax: dto.tax,
    fp: dto.fp,
    legalName: dto.legalName,
    cif: dto.cif,
    idMyS: dto.idMyS,
    isVariable: dto.isVariable,
    invoicePartner: dto.invoicePartner,
  });
}
